// action types
export const BACK_TO_SIGN_IN = 'BACK_TO_SIGN_IN';

// steps
export const FORGOT_YOUR_PASSWORD = 'FORGOT_YOUR_PASSWORD';
export const CHECK_YOUR_IN_BOX = 'CHECK_YOUR_IN_BOX;';
export const CHANGE_YOUR_PASSWORD = 'CHANGE_YOUR_PASSWORD';
export const YOURE_ALL_SET = 'YOURE_ALL_SET';
